import { render, staticRenderFns } from "./soissuematerialsdatalist.vue?vue&type=template&id=07e87468&scoped=true&"
import script from "./soissuematerialsdatalist.vue?vue&type=script&lang=js&"
export * from "./soissuematerialsdatalist.vue?vue&type=script&lang=js&"
import style0 from "./soissuematerialsdatalist.vue?vue&type=style&index=0&id=07e87468&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e87468",
  null
  
)

export default component.exports